import React from 'react';
import CharacterVideo from '../../components/home/CharacterVideo';
import style from './HeroCard.module.css';

/**
 * @param {object} props
 * @param {string} props.label      - 상단 설명 텍스트 (예: "오늘의 나트륨 섭취량")
 * @param {string} props.value      - 메인 수치 (예: "1,250")
 * @param {string} props.unit       - 수치 단위 (예: "mg")
 * @param {string} props.goal       - 목표 텍스트 (예: "/ 2,000mg")
 * @param {string} props.level      - 상태 레벨 ("good" | "warn" | "excellent")
 * @param {string} props.levelText  - 상태 텍스트 (예: "양호")
 * @param {string} props.actionText - 버튼 텍스트 (예: "식단 촬영")
 * @param {string} props.image      - 캐릭터 이미지 경로
 * @param {function} props.onAction - 버튼 클릭 핸들러
 */
const HeroCard = ({ label, value, unit, goal, level, levelText, actionText, video ,image, onAction, btnImage }) => {
    return (
        <div className={style.heroCard}>
            <div className={style.heroCardLeft}>
                <div className={style.heroinformBox}>
                    <p className={style.heroLabel}>{label}</p>
                    <p className={style.heroValue}>
                        {value}<span className={style.heroUnit}>{unit}</span>
                    </p>
                    <p className={style.heroGoal}>{goal}</p>
                    <span className={style.heroBadge} data-level={level}>{levelText}</span>
                </div>
                
                <button className={style.heroActionBtn} onClick={onAction}>
                    {btnImage && <img src={btnImage} alt="" draggable={false} />}
                    {actionText}
                </button>
            </div>
            
            <div className={style.heroCharacter}>
                {image && <img src={image} alt="" draggable={false} />}
            </div>

        </div>
    );
};

export default HeroCard;